/* ==========================================================================
   EGM custom JS (was inlined at the top of assets/app.min.js)
   Loaded in layout/theme.liquid right after app.min.js.
   ========================================================================== */

$(document).ready(function() {
      $(document).on('click', '.click_check', function(){
        var egmCartDrawer = document.getElementById('Cart-Drawer');
        if (egmCartDrawer && typeof egmCartDrawer.refresh === 'function') egmCartDrawer.refresh();
      });
      $(document).on('click', '.cart_drawer_qty_box .plus', function(){
        
        $('.side-panel-content .mini-cart').addClass('mini-cart_disable_click');
        // debugger;
    });
    $(document).on('click', '.cart_drawer_qty_box .minus', function(){
        
        $('.side-panel-content .mini-cart').addClass('mini-cart_disable_click');
        // debugger;
    });

   $(document).on("click", ".cart_recomendation_qty_box .plus, .cart_recomendation_qty_box .minus", function () {
      const $box = $(this).closest(".cart_recomendation_qty_box");
      const $input = $box.find(".qty");
      let value = parseInt($input.val());
      const max = 10;
      const min = 1;
    
      if ($(this).hasClass("plus") && value < max) {
        value++;
      } else if ($(this).hasClass("minus") && value > min) {
        value--;
      }
    
      $input.val(value);
      console.log("Updated value:", value);
      $(this).closest('.product_after_shop_loop_buttons')
             .find('.product-card--add-to-cart-button-simple')
             .attr('qtyadd', value); 
    });

  });
function initSwiperIfNeeded() {
  const slider = document.querySelector('.cart-side-slider');
  if (slider && !slider.classList.contains('swiper-initialized')) {
    new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 16,
      loop: true,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

/* Lo slider del cart drawer viene ricreato quando il carrello si aggiorna:
   l'osservatore resta, ma il controllo gira al massimo una volta per frame
   invece che a ogni singola modifica della pagina. */
let egmSwiperCheckQueued = false;
const observer = new MutationObserver(() => {
  if (egmSwiperCheckQueued) return;
  egmSwiperCheckQueued = true;
  requestAnimationFrame(() => {
    egmSwiperCheckQueued = false;
    initSwiperIfNeeded();
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initial call
document.addEventListener('DOMContentLoaded', function () {
  initSwiperIfNeeded();
});

/* --------------------------------------------------------------------------
   North 11 compatibility: the cart drawer is now <cart-drawer inert> and is
   normally opened by OverlayManager. custom-reseller.js (page.reseller) opens
   it by adding the .open class, so mirror that class onto the inert attribute,
   otherwise the drawer would be visible but not clickable.
   -------------------------------------------------------------------------- */
(function () {
  function bridge() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('open');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) drawer.removeAttribute('inert');
      else drawer.setAttribute('inert', '');
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bridge);
  else bridge();
})();